export type KVPositionJSON = {
  x: number
  y: number
  z: number
}

export class KVPosition {
  x: number
  y: number
  z: number

  constructor(x: number, y: number, z: number) {
    this.x = x
    this.y = y
    this.z = z
  }

  static fromJSON(json: KVPositionJSON): KVPosition {
    const position = new KVPosition(json.x, json.y, json.z)
    return position
  }

  static toJSON(position: KVPosition): KVPositionJSON {
    return {
      x: position.x,
      y: position.y,
      z: position.z,
    }
  }
}
